import React, { useState } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getTaskStatusLabels } from "../../../utils/constant";
import { getUserProfileDetails } from "../../../appStore/actions/AppState/action";
import { findUser, getOrdinal, setProfileData } from "../../../utils/helper";
import { useTranslation } from "react-i18next";
import ApprovalCard from "../../../common/ApprovalCard/ApprovalCard";
import SubApprovalCard from "../../../common/SubApprovalCard/SubApprovalCard";

const ApprovalMessage = ({
  taskItem,
  startTaskOpen,
  setStartTaskOpen,
  handleStartTask,
  indx,
  handleClickTaskUpdate,
  handleViewThreadClick,
  tabValue,
  taskTabValue,
}) => {
  const { t } = useTranslation();
  const appConstant = t("AppConstant", { returnObjects: true });
  const taskStatusLabels = getTaskStatusLabels(appConstant);
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const groupmemberdetails = useSelector(
    (state) => state?.arkchatgroup?.groupmember,
  );
  const groupList = useSelector((state) => state?.arkchatgroup?.groupList);
  const userData = useSelector((state) => state?.profile);
  const dispatch = useDispatch();

  const handleShowUserProfile = (userToFindData) => {
    let data = findUser(groupmemberdetails, userToFindData);
    if (!data) {
      setProfileViewModal(true);
      dispatch(getUserProfileDetails(userToFindData)).then((res) => {
        data = res;
        setProfileData(data, setProfileViewData, setProfileViewModal);
      });
    } else {
      setProfileData(data, setProfileViewData, setProfileViewModal);
    }
  };
  const getDepth = (node) => {
    let depth = 1;
    let current = node;

    while (current?.chain) {
      depth++;
      current = current.chain;
    }

    return depth;
  };

  const totalDepth = taskItem?.chain ? getDepth(taskItem.chain) : 0;

  return (
    <Box
      sx={{
        transition: "all 0.2s ease",
      }}
    >
      <Box
        padding="0px 20px 15px 0px"
        key={taskItem?.id + "TaskMessageMain"}
        sx={{}}
        display={"flex"}
        alignItems={"center"}
      >
        <Box
          sx={{
            width: "100%",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: "19.5px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
            padding: "9px 20px 9px 12px",
          }}
        >
          <ApprovalCard
            taskItem={taskItem}
            setStartTaskOpen={setStartTaskOpen}
            handleStartTask={handleStartTask}
            indx={indx}
            handleClickTaskUpdate={handleClickTaskUpdate}
            handleViewThreadClick={handleViewThreadClick}
            tabValue={tabValue}
            taskTabValue={taskTabValue}
            userData={userData}
            groupList={groupList}
            taskStatusLabels={taskStatusLabels}
            setProfileViewModal={setProfileViewModal}
            isProfileViewOpen={isProfileViewOpen}
            profileViewData={profileViewData}
            setProfileViewData={setProfileViewData}
            handleShowUserProfile={handleShowUserProfile}
            startTaskOpen={startTaskOpen}
            levelLabel={getOrdinal(totalDepth+1)}
            buttonType="main"
          />
        </Box>
      </Box>
      {taskItem?.chain && (
        <Box>
          <ApprovalTree
            approvalNode={taskItem.chain}
            level={1}
            indx={indx}
            tabValue={tabValue}
            taskTabValue={taskTabValue}
            totalDepth={totalDepth}
            userData={userData}
            groupList={groupList}
            taskStatusLabels={taskStatusLabels}
            handleClickTaskUpdate={handleClickTaskUpdate}
            handleViewThreadClick={handleViewThreadClick}
            startTaskOpen={startTaskOpen}
            setStartTaskOpen={setStartTaskOpen}
            handleStartTask={handleStartTask}
            handleShowUserProfile={handleShowUserProfile}
            buttonType="sub1"
          />
        </Box>
      )}
    </Box>
  );
};
const ApprovalTree = ({ approvalNode, level = 1, totalDepth, ...props }) => {
  if (!approvalNode) return null;

  const labelNumber = totalDepth - level + 1;

  return (
    <>
      <Box
        padding="0rem 1.25rem 1rem 1.5rem"
        display="flex"
        alignItems="center"
      >
        <SubApprovalCard
          taskItem={approvalNode}
          labelNumber={labelNumber}
          {...props}
        />
      </Box>

      {approvalNode.chain && (
        <ApprovalTree
          approvalNode={approvalNode.chain}
          level={level + 1}
          totalDepth={totalDepth}
          {...props}
        />
      )}
    </>
  );
};

// const ApprovalTree = ({ approvalNode, level = 0, ...props }) => {
//   if (!approvalNode) return null;

//   return (
//     <>
//       {/* CURRENT LEVEL */}
//       <Box
//         padding="0rem 1.25rem 1rem 1.5rem"
//         // key={taskItem?.id + "TaskMessageSub1"}
//         display={"flex"}
//         alignItems={"center"}
//       >
//         <SubApprovalCard
//           taskItem={approvalNode}
//           subIndex={level}
//           buttonType="sub"
//           {...props}
//         />
//       </Box>

//       {/* CHILD NODE */}
//       {approvalNode.chain && (
//         <ApprovalTree
//           approvalNode={approvalNode.chain}
//           level={level + 1}
//           {...props}
//         />
//       )}
//     </>
//   );
// };

export default ApprovalMessage;
